import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelLiquidationListComponent } from './components/travel-liquidation-list/travel-liquidation-list.component';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule, MatAutocompleteModule, MatCheckboxModule, MatButtonModule, MatFormFieldModule, MatTabsModule, MatSelectModule, MatDatepickerModule, MatIconModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TravelLiquiditionService } from './services/travel-liquidition/travel-liquidition.service';
import { TravelLiquidationAddComponent } from './components/travel-liquidation-add/travel-liquidation-add.component';
import { TravelLiquidationViewComponent } from './components/travel-liquidation-view/travel-liquidation-view.component';
import { TravelLiquidationCancelComponent } from './components/travel-liquidation-cancel/travel-liquidation-cancel.component';
import { TravelLiquidationApproveListComponent } from './components/travel-liquidation-approve-list/travel-liquidation-approve-list.component';
import { TravelLiquidationApproverComponent } from './components/travel-liquidation-approver/travel-liquidation-approver.component';
import { TravelLiquidationApproverViewComponent } from './components/travel-liquidation-approver-view/travel-liquidation-approver-view.component';

@NgModule({
  declarations: [
    TravelLiquidationListComponent,
    TravelLiquidationAddComponent,
    TravelLiquidationViewComponent,
    TravelLiquidationCancelComponent,
    TravelLiquidationApproveListComponent,
    TravelLiquidationApproverComponent,
    TravelLiquidationApproverViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  exports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule
  ],
  providers:[    
    TravelLiquiditionService
  ],
  entryComponents:[
    TravelLiquidationAddComponent,
    TravelLiquidationViewComponent,
    TravelLiquidationCancelComponent,
    TravelLiquidationApproveListComponent,
    TravelLiquidationApproverViewComponent
  ]
})
export class TravelLiquidationModule { }
